module.exports = __webpack_public_path__ + "static/img/title-sm.e076acc.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/title-sm.png
// module id = WNvH
// module chunks = 41